// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel {
    flex-grow: 1;
    padding: 2rem;
    background-color: var(--clr-white);
    overflow-y: auto;
    min-height: 100%; 
    transition: var(--darkModeTransition);
  }
  
  @media (max-width: 768px) {
    .main-panel {
      padding: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/MainPanel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;EACvC;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":[".main-panel {\n    flex-grow: 1;\n    padding: 2rem;\n    background-color: var(--clr-white);\n    overflow-y: auto;\n    min-height: 100%; \n    transition: var(--darkModeTransition);\n  }\n  \n  @media (max-width: 768px) {\n    .main-panel {\n      padding: 1rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
